<template>
  <div
    class="flip-card"
    @click="flipCard()"
    :class="[
      { selected: isSelected(item.id) },
      { flipped: flipped },
      { dark: dark },
    ]"
  >
    <div class="front card" :class="[{ hasImage: item.image }]">
      <div
        class="card_image mb-2"
        :style="'background: url(' + item.image + ')'"
        v-if="item.image"
      >
        <div class="card_title">
          <h2><img :src="item.icon" v-if="item.icon" /> {{ item.name }}</h2>
        </div>
      </div>
      <div v-else>
        <h2><img :src="item.icon" v-if="item.icon" />{{ item.name }}</h2>
      </div>
      <span class="single_use" v-if="item.single_use">One Time Play</span>
      <span class="regen" v-else>Regenerative</span>
      <p class="description">{{ item.text }}</p>
      <div class="indicators">
        <p
          class="indicator"
          v-for="(indicator, index) in item.indicators"
          :key="index"
        >
          {{ indicator }}
        </p>
      </div>
      <!-- <p class="select" v-if="isSelected(item.id)">Selected</p> -->
    </div>
    <div class="back" @click="select(item.id, item.single_use)">
      <h2>Gameplay</h2>
      <p>{{ item.gameplay }}</p>
      <button
        class="select"
        v-if="
          !isSelected(item.id) &&
            checkHand(item.single_use) &&
            selectable == true
        "
      >
        Add to my deck
      </button>
      <button class="remove" v-if="isSelected(item.id)">
        Remove from my deck
      </button>
      <p
        class="remaining"
        v-if="$store.user.cards.length <= 4 && selectable == true"
      >
        You have {{ 5 - $store.user.cards.length }} cards remaining
      </p>
      <button
        class="play bg-black text-white py-2 font-bold px-6 rounded-full"
        v-if="playable == true"
        @click="play(item.id)"
      >
        Play Card
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Card",
  data: () => ({ flipped: false }),
  props: ["item", "selectable", "playable", "flip", "dark"],
  methods: {
    flipCard() {
      this.flipped != this.flipped;
    },
    play(id) {
      this.$emit("played", id);
    },
    select(id, single) {
      if (!this.isSelected(id) && this.selectable && this.checkHand(single)) {
        if (this.$store.user.cards.length < 5) {
          this.$store.user.cards.push(id);
        }
      } else {
        const index = this.$store.user.cards.indexOf(id);
        if (index > -1) {
          this.$store.user.cards.splice(index, 1);
        }
      }
    },
    isSelected(id) {
      if (this.$store.user.cards.includes(id) && this.selectable == true) {
        return true;
      } else {
        return false;
      }
    },
    checkHand(single) {
      if (single) {
        if (this.single_use < 3) {
          return true;
        } else {
          return false;
        }
      }
      if (!single) {
        if (this.regen < 2) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  computed: {
    userCards() {
      if (this.$store.user && this.$store.user.cards) {
        return this.$store.cards.filter((el) => {
          return this.$store.user.cards.includes(el.id);
        });
      } else {
        return false;
      }
    },
    regen() {
      if (this.userCards) {
        var cards = this.userCards.filter((x) => !x.single_use);
        return cards.length;
      } else {
        return 0;
      }
    },
    single_use() {
      if (this.userCards) {
        var cards = this.userCards.filter((x) => x.single_use);
        return cards.length;
      } else {
        return 0;
      }
    },
  },
  async created() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.single_use,
.regen {
  background: orange;
  color: white;
  font-weight: 800;
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
  @apply py-2 mb-3 mt-1 text-xs px-4 rounded-full;
}

.regen {
  background: green;
}

.front,
.back {
  @apply border shadow-lg;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgb(253, 253, 253) 90%,
    rgb(247, 247, 247) 100%
  );
  position: relative;
  border-radius: 0px;
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.hasImage {
    justify-content: space-between;

    p.description {
      flex-grow: 1;
    }
  }

  p {
    padding: 0 20px;
  }
}

.card {
  min-height: 430px;
  height: auto;
  position: relative;

  h2 {
    display: flex;
    font-family: "Times New Roman", Times, serif;
    @apply text-xl mt-4;
    font-weight: 100;
    align-items: center;
    justify-content: center;
    width: auto;
    position: relative;
    padding-bottom: 30px;

    .icon {
      img {
        height: 25px !important;
        margin: 0;
      }
    }
  }

  p.description {
    font-family: Georgia, serif;
    position: relative;
    @apply px-6 leading-tight;
  }

  .card_image {
    width: 100%;
    height: 180px;
    border-radius: 0px;
    background-size: cover !important;
    background-position: 50% 50% !important;
    display: flex;
    align-self: start !important;
    align-items: center;
    justify-content: center;
    position: relative;

    .card_title {
      display: flex;
      position: absolute;
      width: 100%;
      bottom: 0px;
      margin: 0;
      align-items: flex-end;
      justify-content: center;
      height: 40%;
      text-align: center !important;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      color: white;
      padding: 0 0 15px 0;

      h2 {
        padding-bottom: 0;
      }

      img {
        height: 23px;
        margin: 5px 5px 0 0;
      }
    }
  }
}

.image {
  height: 400px;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: start;

  &:after {
    position: absolute;
    content: "";
    background: linear-gradient(
      125deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 26%,
      rgba(255, 255, 255, 0) 100%
    );
    width: 100%;
    height: 100%;
  }

  .wrapper {
    width: 70%;
    margin-left: 7%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  h1 {
    display: inline-block;
    color: black;
    font-size: 3rem;
    margin: 0;
    text-transform: capitalize;
  }

  p {
    width: 60%;
    margin: 0;
    font-weight: light;
    font-size: 1.2rem;
  }

  .wrapper {
    position: relative;
    z-index: 9;
  }
}

.selected .select {
  background: green;
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  font-weight: bold;
  padding: 14px 30px;
  margin: 0;
}

p.gameplay {
  display: block;
  padding: 0 20px;
}

.flip-card {
  display: inline-flex;
  align-content: stretch;
  min-height: 390px;
  width: 90%;
  margin: 0 auto 30px;
  flex-wrap: wrap;
  position: relative;
  padding: 0px;
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;

  &.selected {
    .front,
    .back {
      border: 10px solid rgb(147, 185, 147);
    }
  }

  &.flipped {
    .back {
      transform: rotateY(0deg);
      z-index: 10;
    }

    .front {
      transform: rotateY(180deg);
      z-index: -1;
    }
  }

  &:hover {
    cursor: pointer;

    .back {
      transform: rotateY(0deg);
      z-index: 10;
    }

    .front {
      transform: rotateY(180deg);
      z-index: -1;
    }
  }

  .back,
  .front {
    position: relative;
    -webkit-backface-visibility: hidden;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-content: center;
    height: auto;
    flex: 0 0 100%;
    border: 10px solid white;
    -webkit-transition: all 1s cubic-bezier(0.5, 1, 0.5, 1);
    transition: all 1s cubic-bezier(0.5, 1.3, 0.5, 1.3);
    transform-style: preserve-3d;
    background-size: cover !important;
    background-position: center;
    background-repeat: no-repeat;
  }

  .back {
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    padding: 50px 0;
    bottom: 0;
    width: 100%;
    transform: rotateY(-180deg);

    h2 {
      @apply mt-4 mb-2 text-lg font-bold;

      text-decoration: underline;
    }

    p {
      padding: 0 25px;
      @apply mb-4;
    }
  }

  .front {
    z-index: 10;

    .content {
      @apply text-lg px-2 py-3 w-full font-bold absolute;
      top: 0% !important;
      height: 90px;
      z-index: 9;
      color: white;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      &:before {
        content: "";
        @apply absolute;
        bottom: 0;
        left: 0;
        z-index: -1;
        height: 200px;
        width: 100%;
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      }
    }
  }

  .indicators {
    @apply mt-4 mb-4;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 90%;

    p {
      @apply mb-2;
      border: 0.5px solid #ddd;
      border-radius: 100px;
      padding: 6px 13px 4px;
      font-size: 0.6rem;
      font-weight: bold;
      text-transform: uppercase;
      margin-right: 10px;
    }
  }

  .content {
    -webkit-transform: translateZ(50px);
    transform: translateZ(50px);
  }
}

.back {
  button.select,
  button.remove {
    background: none;
    padding: 10px 15px;
    @apply text-xs mb-3;
    border-radius: 100px;
    font-weight: bold;

    &.select {
      border: 2px solid rgb(35, 141, 35);
      color: rgb(35, 141, 35);

      &:hover {
        cursor: pointer;
        background-color: rgb(35, 141, 35);
        color: white;
      }
    }

    &.remove {
      border: 2px solid rgb(173, 20, 20);
      background-color: rgb(173, 20, 20);
      color: white;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.remaining {
  font-size: 0.9rem;
  font-style: italic;
  color: rgb(124, 124, 124);
}

.flip-card.noHover {
  .back,
  .front {
    transition: none !important;
    @apply rounded-lg;
    min-height: 490px;
    .card_image {
      height: 300px;
    }
  }

  &:hover {
    cursor: pointer;

    .back {
      display: none;
    }

    .front {
      transform: none !important;
      z-index: 10 !important;
    }
  }
}

.flip-card {
  &.dark {
    @apply shadow-lg;
    .front {
      border-radius: 10px;
      border: 10px solid rgba(255, 255, 255, 0.1) !important;
    }
  }
}
</style>
